var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 2.5,
    stroke: "var(--klothed-textColor)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36745 6.1281C7.36745 6.75113 6.82742 7.2562 6.16126 7.2562C5.49511 7.2562 4.95508 6.75113 4.95508 6.1281C4.95508 5.50507 5.49511 5 6.16126 5C6.82742 5 7.36745 5.50507 7.36745 6.1281Z",
    fill: "var(--klothed-textColor)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12003 8.0854H7.18188V14.3333H5.12003V8.0854Z",
    fill: "var(--klothed-textColor)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5015 8.0854H8.43961V14.3333H10.5015C10.5015 14.3333 10.5015 12.3664 10.5015 11.1366C10.5015 10.3984 10.7535 9.65702 11.7592 9.65702C12.8958 9.65702 12.8889 10.623 12.8836 11.3714C12.8767 12.3496 12.8932 13.3479 12.8932 14.3333H14.9551V11.0358C14.9376 8.93025 14.389 7.96005 12.5839 7.96005C11.512 7.96005 10.8476 8.44671 10.5015 8.88699V8.0854Z",
    fill: "var(--klothed-textColor)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.50f0e8d5153c979174f411a9e24864a8.svg";
export { ForwardRef as ReactComponent };